import {
  addAgent,
  clearAgent,
  loadAllAgent,
  loadSingleAgent,
  updateAgent,
} from "@/redux/rtk/features/CRM/agent/agentSlice";
import { Button, Form } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CompanyInformation from "./CompanyInformation";

export default function AddCompany({ data, drawer }) {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem("id");
  const { agent: company, loading: companyLoading } = useSelector(
    (state) => state.agent
  );

  const onFinish = async (values) => {
    setLoader(true);
    const formData = {
      ...values,
      companySize: Number(values.companySize),
      annualRevenue: Number(values.annualRevenue),
    };
    let resp;

    // checking if i have id i will hit update or i will hit add
    if (data?.id) {
      resp = await dispatch(updateAgent({ id: data.id, values: formData }));
      if (resp.payload.message === "success") {
        dispatch(loadAllAgent());
      }
    } else {
      resp = await dispatch(addAgent(formData));
    }
    console.log(resp);
    if (resp.payload.message === "success") {
      form.resetFields();
      dispatch(loadAllAgent());
      !drawer ? navigate(`/admin/company/${resp?.payload?.data?.id}`) : "";
    }
    setLoader(false);
  };

  const [current, setCurrent] = useState(0);

  const next = async () => {
    try {
      // Validate fields for the current step before proceeding
      await form.validateFields();
      setCurrent(current + 1);
    } catch (error) {
      console.error(t("form.validationFailed"), error);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "",
      content: <CompanyInformation key={t("company.companyInformation")} form={form} company={company} />,
    },
  ];

  useEffect(() => {
    if (!data?.id && userId) {
      form.setFieldsValue({
        companyOwnerId: parseInt(userId),
      });
    }
  }, [form, userId, data]);

  useEffect(() => {
    if (data?.id) {
      dispatch(loadSingleAgent(data.id)).then(() => {
        form.setFieldsValue({
          ...data,
        });
      });
    } else {
      form.resetFields();
    }

    return () => dispatch(clearAgent());
  }, [data, dispatch, form]);

  useEffect(() => {
    dispatch(loadSingleAgent(data?.id));
    return () => {
      clearAgent();
    };
  }, [data?.id, dispatch]);
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{
          marginTop: 50,
          width: "80%",
          marginLeft: "auto",
          marginRight: "auto",
        }}>
        <div>
          {steps[0].content}
        </div>

        <div style={{ marginTop: 24, textAlign: "right" }}>
          <Button
            className="mb-5"
            type="primary"
            htmlType="submit"
            loading={loader}>
            {t("common.submit")}
          </Button>
        </div>
      </Form>
    </>
  );
}
